import { Component, Inject, OnInit } from "@angular/core";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import * as moment from "moment";

import { AlertService, MediaWatcherService } from "../../_services";
import { AppGlobals } from "../../app.globals";

@Component({
    templateUrl: "registerDobConfirmationDialog.component.html",
    styleUrls: ["registerDobConfirmationDialog.component.css"]
})
export class RegisterDobConfirmationDialogComponent implements OnInit {
    registerDobFormGroup: UntypedFormGroup;
    studentRegistrations: any[];
    mediaWatcherSubscription: Subscription;
    isMobile = false;

    constructor(private dialogRef: MatDialogRef<RegisterDobConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        public dialog: MatDialog,
        private formBuilder: UntypedFormBuilder,
        private appGlobals: AppGlobals,
        private alertService: AlertService,
        private mediaWatcherService: MediaWatcherService) {
        this.studentRegistrations = data.studentRegistrations;
    }

    ngOnInit() {
        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;
        });

        this.initializeForm();
    }

    initializeForm() {
        this.registerDobFormGroup = this.formBuilder.group({
            dateOfBirth: [{ value: "", disabled: false }, Validators.required],
            isGraduateStudent: [{ value: false, disabled: false }],
        });
    }

    get registerDobFormControls() { return this.registerDobFormGroup.controls as any; }

    close() {
        this.dialogRef.close(false);
    }

    checkDateOfBirth() {
        if (this.registerDobFormGroup.invalid) {
            return;
        }

        if (this.registerDobFormGroup.dirty) {
            let errorFound = false;

            const matchingStudentRegistration = this.studentRegistrations.find(f => f.schoolId === (this.registerDobFormControls.isGraduateStudent.value ? 2 : 1) && moment(this.registerDobFormControls.dateOfBirth.value).format("YYYY-MM-DD") === moment(f.dateOfBirth).format("YYYY-MM-DD"));

            if (matchingStudentRegistration) {
                this.alertService.showMessage(`An account with the same details already exists. The login email for this account is ${matchingStudentRegistration.email}. Please contact the admissions office if this is not your account.`, "Registration", this.appGlobals.alertMessageTypes.error);

                errorFound = true;
            }

            this.dialogRef.close(errorFound);
        }
    }
}